const MS_PER_HOUR = 60 * 60 * 1000
const MS_PER_DAY = 24 * MS_PER_HOUR
const SEVEN_DAYS_MS = 7 * MS_PER_DAY

function startOfLocalCalendarDay(date: Date): number {
  const local = new Date(date)
  local.setHours(0, 0, 0, 0)
  return local.getTime()
}

/** Whole calendar days from `now`'s local date until `expiresAt`'s local date (0 = same day). */
export function localCalendarDaysUntilExpiry(expiresAt: Date, now: Date = new Date()): number {
  return Math.round(
    (startOfLocalCalendarDay(expiresAt) - startOfLocalCalendarDay(now)) / MS_PER_DAY
  )
}

export type RetentionDisplay =
  { variant: 'days'; daysRemaining: number } | { variant: 'tomorrow' } | { variant: 'today' }

export type RetentionVariant = RetentionDisplay['variant']

export function resolveExpiresAt(expiresAt?: string) {
  if (expiresAt === undefined) {
    return null
  }

  const parsed = new Date(expiresAt)
  if (Number.isNaN(parsed.getTime())) {
    return null
  }

  return parsed
}

export function getRetentionDisplay(
  expiresAt: Date,
  now: Date = new Date()
): RetentionDisplay | null {
  const remainingMs = expiresAt.getTime() - now.getTime()
  // Past expiry means the backend has already deleted the file; never warn about the past.
  if (remainingMs <= 0) {
    return null
  }

  if (remainingMs > SEVEN_DAYS_MS) {
    return null
  }

  const calendarDaysUntil = localCalendarDaysUntilExpiry(expiresAt, now)

  if (calendarDaysUntil >= 2) {
    return {
      variant: 'days',
      daysRemaining: calendarDaysUntil,
    }
  }

  if (calendarDaysUntil === 1) {
    return { variant: 'tomorrow' }
  }

  return { variant: 'today' }
}
